/**
 * Rocksoft Locations Settings API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { AddRestrictionsProfileToCategoryCommand } from '../model/addRestrictionsProfileToCategoryCommand';
// @ts-ignore
import { CategoryRestrictionsProfileConfiguration } from '../model/categoryRestrictionsProfileConfiguration';
// @ts-ignore
import { CategoryType } from '../model/categoryType';
// @ts-ignore
import { ErrorResponse } from '../model/errorResponse';
// @ts-ignore
import { ModelNameFlags } from '../model/modelNameFlags';
// @ts-ignore
import { SetRestrictionsProfilesForCategoryCommand } from '../model/setRestrictionsProfilesForCategoryCommand';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';


export interface AddRestrictionsProfileToCategoryRequestParams {
    /** The type of the category. */
    categoryType: CategoryType;
    /** The persistent category id. */
    categoryId: string;
    /** The command to add or update the restrictions profile for the category. */
    addRestrictionsProfileToCategoryCommand?: AddRestrictionsProfileToCategoryCommand;
}

export interface DeleteRestrictionsProfileFromCategoryRequestParams {
    /**  */
    categoryType: CategoryType;
    /**  */
    categoryId: string;
    /**  */
    restrictionsProfilePresetId: string;
    /**  */
    models?: Array<ModelNameFlags>;
}

export interface GetRestrictionsProfileForCategoryRequestParams {
    /** The type of the category. */
    categoryType: CategoryType;
    /** The persistent category id. */
    categoryId: string;
    /** The restrictions profile preset id. */
    restrictionsProfilePresetId: string;
    /** Optional, the models to filter on. */
    models?: Array<ModelNameFlags>;
}

export interface GetRestrictionsProfilesForCategoryRequestParams {
    /** The type of the category. */
    categoryType: CategoryType;
    /** The persistent category id. */
    categoryId: string;
    /** Optional, the models to filter on. */
    models?: Array<ModelNameFlags>;
}

export interface PutRestrictionsProfileToCategoryRequestParams {
    /** The type of the category. */
    categoryType: CategoryType;
    /** The persistent category id. */
    categoryId: string;
    /** The command to set the restrictions profiles for the category. */
    setRestrictionsProfilesForCategoryCommand?: SetRestrictionsProfilesForCategoryCommand;
}


@Injectable({
  providedIn: 'root'
})
export class CategoryRestrictionsProfileConfigurationService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Adds or updates restrictions profiles for a category. If a restrictions profile with the same preset id already exists for the category, it will be updated, otherwise a new restrictions profile will be added.
     * @endpoint post /categories/{categoryType}/{categoryId}/integrations/mdm/restrictions-profiles
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public addRestrictionsProfileToCategory(requestParameters: AddRestrictionsProfileToCategoryRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<CategoryRestrictionsProfileConfiguration>;
    public addRestrictionsProfileToCategory(requestParameters: AddRestrictionsProfileToCategoryRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<CategoryRestrictionsProfileConfiguration>>;
    public addRestrictionsProfileToCategory(requestParameters: AddRestrictionsProfileToCategoryRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<CategoryRestrictionsProfileConfiguration>>;
    public addRestrictionsProfileToCategory(requestParameters: AddRestrictionsProfileToCategoryRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const categoryType = requestParameters?.categoryType;
        if (categoryType === null || categoryType === undefined) {
            throw new Error('Required parameter categoryType was null or undefined when calling addRestrictionsProfileToCategory.');
        }
        const categoryId = requestParameters?.categoryId;
        if (categoryId === null || categoryId === undefined) {
            throw new Error('Required parameter categoryId was null or undefined when calling addRestrictionsProfileToCategory.');
        }
        const addRestrictionsProfileToCategoryCommand = requestParameters?.addRestrictionsProfileToCategoryCommand;

        let localVarHeaders = this.defaultHeaders;

        // authentication (azureb2c) required
        localVarHeaders = this.configuration.addCredentialToHeaders('azureb2c', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/categories/${this.configuration.encodeParam({name: "categoryType", value: categoryType, in: "path", style: "simple", explode: false, dataType: "CategoryType", dataFormat: undefined})}/${this.configuration.encodeParam({name: "categoryId", value: categoryId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/integrations/mdm/restrictions-profiles`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<CategoryRestrictionsProfileConfiguration>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: addRestrictionsProfileToCategoryCommand,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Deletes a restrictions profile from a category.
     * @endpoint delete /categories/{categoryType}/{categoryId}/integrations/mdm/restrictions-profiles/{restrictionsProfilePresetId}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public deleteRestrictionsProfileFromCategory(requestParameters: DeleteRestrictionsProfileFromCategoryRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public deleteRestrictionsProfileFromCategory(requestParameters: DeleteRestrictionsProfileFromCategoryRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public deleteRestrictionsProfileFromCategory(requestParameters: DeleteRestrictionsProfileFromCategoryRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public deleteRestrictionsProfileFromCategory(requestParameters: DeleteRestrictionsProfileFromCategoryRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const categoryType = requestParameters?.categoryType;
        if (categoryType === null || categoryType === undefined) {
            throw new Error('Required parameter categoryType was null or undefined when calling deleteRestrictionsProfileFromCategory.');
        }
        const categoryId = requestParameters?.categoryId;
        if (categoryId === null || categoryId === undefined) {
            throw new Error('Required parameter categoryId was null or undefined when calling deleteRestrictionsProfileFromCategory.');
        }
        const restrictionsProfilePresetId = requestParameters?.restrictionsProfilePresetId;
        if (restrictionsProfilePresetId === null || restrictionsProfilePresetId === undefined) {
            throw new Error('Required parameter restrictionsProfilePresetId was null or undefined when calling deleteRestrictionsProfileFromCategory.');
        }
        const models = requestParameters?.models;

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'models',
            <any>models,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (azureb2c) required
        localVarHeaders = this.configuration.addCredentialToHeaders('azureb2c', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/categories/${this.configuration.encodeParam({name: "categoryType", value: categoryType, in: "path", style: "simple", explode: false, dataType: "CategoryType", dataFormat: undefined})}/${this.configuration.encodeParam({name: "categoryId", value: categoryId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/integrations/mdm/restrictions-profiles/${this.configuration.encodeParam({name: "restrictionsProfilePresetId", value: restrictionsProfilePresetId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('delete', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets a specific restrictions profile for a category by the restrictions profile preset id.
     * @endpoint get /categories/{categoryType}/{categoryId}/integrations/mdm/restrictions-profiles/{restrictionsProfilePresetId}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getRestrictionsProfileForCategory(requestParameters: GetRestrictionsProfileForCategoryRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<CategoryRestrictionsProfileConfiguration>;
    public getRestrictionsProfileForCategory(requestParameters: GetRestrictionsProfileForCategoryRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<CategoryRestrictionsProfileConfiguration>>;
    public getRestrictionsProfileForCategory(requestParameters: GetRestrictionsProfileForCategoryRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<CategoryRestrictionsProfileConfiguration>>;
    public getRestrictionsProfileForCategory(requestParameters: GetRestrictionsProfileForCategoryRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const categoryType = requestParameters?.categoryType;
        if (categoryType === null || categoryType === undefined) {
            throw new Error('Required parameter categoryType was null or undefined when calling getRestrictionsProfileForCategory.');
        }
        const categoryId = requestParameters?.categoryId;
        if (categoryId === null || categoryId === undefined) {
            throw new Error('Required parameter categoryId was null or undefined when calling getRestrictionsProfileForCategory.');
        }
        const restrictionsProfilePresetId = requestParameters?.restrictionsProfilePresetId;
        if (restrictionsProfilePresetId === null || restrictionsProfilePresetId === undefined) {
            throw new Error('Required parameter restrictionsProfilePresetId was null or undefined when calling getRestrictionsProfileForCategory.');
        }
        const models = requestParameters?.models;

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'models',
            <any>models,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (azureb2c) required
        localVarHeaders = this.configuration.addCredentialToHeaders('azureb2c', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/categories/${this.configuration.encodeParam({name: "categoryType", value: categoryType, in: "path", style: "simple", explode: false, dataType: "CategoryType", dataFormat: undefined})}/${this.configuration.encodeParam({name: "categoryId", value: categoryId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/integrations/mdm/restrictions-profiles/${this.configuration.encodeParam({name: "restrictionsProfilePresetId", value: restrictionsProfilePresetId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<CategoryRestrictionsProfileConfiguration>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets the restrictions profiles for a category.
     * @endpoint get /categories/{categoryType}/{categoryId}/integrations/mdm/restrictions-profiles
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getRestrictionsProfilesForCategory(requestParameters: GetRestrictionsProfilesForCategoryRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<CategoryRestrictionsProfileConfiguration>>;
    public getRestrictionsProfilesForCategory(requestParameters: GetRestrictionsProfilesForCategoryRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<CategoryRestrictionsProfileConfiguration>>>;
    public getRestrictionsProfilesForCategory(requestParameters: GetRestrictionsProfilesForCategoryRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<CategoryRestrictionsProfileConfiguration>>>;
    public getRestrictionsProfilesForCategory(requestParameters: GetRestrictionsProfilesForCategoryRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const categoryType = requestParameters?.categoryType;
        if (categoryType === null || categoryType === undefined) {
            throw new Error('Required parameter categoryType was null or undefined when calling getRestrictionsProfilesForCategory.');
        }
        const categoryId = requestParameters?.categoryId;
        if (categoryId === null || categoryId === undefined) {
            throw new Error('Required parameter categoryId was null or undefined when calling getRestrictionsProfilesForCategory.');
        }
        const models = requestParameters?.models;

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'models',
            <any>models,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (azureb2c) required
        localVarHeaders = this.configuration.addCredentialToHeaders('azureb2c', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/categories/${this.configuration.encodeParam({name: "categoryType", value: categoryType, in: "path", style: "simple", explode: false, dataType: "CategoryType", dataFormat: undefined})}/${this.configuration.encodeParam({name: "categoryId", value: categoryId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/integrations/mdm/restrictions-profiles`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<CategoryRestrictionsProfileConfiguration>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Sets the restrictions profiles for a category. This will replace all existing restrictions profile configurations for the category with the given ones.
     * @endpoint put /categories/{categoryType}/{categoryId}/integrations/mdm/restrictions-profiles
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public putRestrictionsProfileToCategory(requestParameters: PutRestrictionsProfileToCategoryRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<CategoryRestrictionsProfileConfiguration>>;
    public putRestrictionsProfileToCategory(requestParameters: PutRestrictionsProfileToCategoryRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<CategoryRestrictionsProfileConfiguration>>>;
    public putRestrictionsProfileToCategory(requestParameters: PutRestrictionsProfileToCategoryRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<CategoryRestrictionsProfileConfiguration>>>;
    public putRestrictionsProfileToCategory(requestParameters: PutRestrictionsProfileToCategoryRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const categoryType = requestParameters?.categoryType;
        if (categoryType === null || categoryType === undefined) {
            throw new Error('Required parameter categoryType was null or undefined when calling putRestrictionsProfileToCategory.');
        }
        const categoryId = requestParameters?.categoryId;
        if (categoryId === null || categoryId === undefined) {
            throw new Error('Required parameter categoryId was null or undefined when calling putRestrictionsProfileToCategory.');
        }
        const setRestrictionsProfilesForCategoryCommand = requestParameters?.setRestrictionsProfilesForCategoryCommand;

        let localVarHeaders = this.defaultHeaders;

        // authentication (azureb2c) required
        localVarHeaders = this.configuration.addCredentialToHeaders('azureb2c', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/categories/${this.configuration.encodeParam({name: "categoryType", value: categoryType, in: "path", style: "simple", explode: false, dataType: "CategoryType", dataFormat: undefined})}/${this.configuration.encodeParam({name: "categoryId", value: categoryId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/integrations/mdm/restrictions-profiles`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<CategoryRestrictionsProfileConfiguration>>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: setRestrictionsProfilesForCategoryCommand,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
